import styled from 'styled-components';

import { ANIMATION, COLOURS } from '../../consts/style';
import { BREAK_POINTS } from '../../consts/styleDedupe';
import { headingLinkOnHoverMixin } from '../Text';
import { InlineSvg } from '../Svg';

export const HelpSupportContainer = styled.div`
  h2 {
    text-align: center;
  }
`;

export const StyledSvg = styled(InlineSvg)`
  padding-bottom: 24px;
  display: inline-block;

  svg {
    fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    height: 48px;
    margin-top: 8px;
    transition: transform ${ANIMATION.ICON.SPEED};
  }
` as any;

export const StyledHelpItem = styled.article`
  display: block;
  box-sizing: border-box;
  width: 100%;
  text-align: center;

  @media (max-width: ${BREAK_POINTS.Min.MD}) {
    padding: 0 15px 48px;
  }

  > a {
    ${headingLinkOnHoverMixin};

    cursor: pointer;

    text-decoration: none;
    line-height: 1;

    &:visited {
      color: inherit;
    }

    &:hover {
      ${StyledSvg} > svg {
        transform: scale(${ANIMATION.ICON.SCALE});
      }
    }
    h4 {
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      font-weight: normal;
      color: ${COLOURS.PRIMARY.GREY};
      line-height: 1.71;
    }
  }
`;

export const HelpItemsList = styled.div`
  box-sizing: border-box;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: flex;

    & > * {
      width: calc(33.33% - 2 / 3 * 24px);
    }
    & > *:not(:first-child) {
      margin-left: 24px;
    }
  }

  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    & > * {
      width: calc(33.33% - 2 / 3 * 48px);
    }
    & > *:not(:first-child) {
      margin-left: 48px;
    }
  }

  @media screen and (min-width: ${BREAK_POINTS.Min.XL}) {
    & > * {
      width: calc(33.33% - 2 / 3 * 64px);
    }
    & > *:not(:first-child) {
      margin-left: 64px;
    }
  }
`;
